var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcXlsx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 2.00781C2.66663 0.903243 3.56206 0.0078125 4.66663 0.0078125H20.0195L29.3333 9.28288V30.0078C29.3333 31.1124 28.4379 32.0078 27.3333 32.0078H4.66662C3.56205 32.0078 2.66663 31.1124 2.66663 30.0078V2.00781Z",
    fill: "#5AD6A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0104 0.0078125V8.27246C20.0104 8.82475 20.4581 9.27246 21.0104 9.27246H29.3333",
    fill: "#99EDC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1094 25.8413H18.1875L16 21.9194L13.6875 25.8413H10.8906L14.5938 19.9741L11.0703 14.3257H13.9453L16 18.0679L18.1094 14.3257H20.8906L17.3672 19.8804L21.1094 25.8413Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXlsx);
export default __webpack_public_path__ + "static/media/ic_xlsx.c0a969bdcd1e76dfdbbb818293039def.svg";
export { ForwardRef as ReactComponent };